export default function(state = this.initialValue, action) {
    switch (action.type) {
        case this.resultAction:
            return {success: true, result: action.payload.data};
        case this.failureAction:
            return {success: false, result: action.payload};
        default:
            return state;
    }
};